<template>
<div class="menu">
  <div class="sidebar hidden lg:block">
    <div class="recentPosts">
      <h4 class="bgLiveBlack text-white py-3 px-4 tracking-wider">最新文章</h4>
      <ul class="px-3 textColorBlack tracking-wider">
        <li class="text-base border-b py-3 border-dashed borderColordarkgray2" v-for="(item, index) in relatedData" :key="index">
          <router-link :to="{name: 'topicDetail', params: { id: item.id }}" class="article-title">
            <div class="w-full">
              <p class="text">【{{ item.category_name }}】{{ item.title }}</p>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="categories mb-4">
      <h4 class="bgLiveBlack text-white py-3 px-4 mb-2 tracking-wider">文章分類</h4>
      <ul class="text-base px-4 textColorBlack tracking-wider">
        <li class="py-1">
          <router-link :to="{name: 'topicList'}">
            未分類 ({{ uncatagorized }})
          </router-link>
        </li>
        <li class="py-1" v-for="(item, index) in categories" :key="index">
          <router-link :to="{name: 'topicList', params: { topicCategory: item.id }}">
            {{ item.name }} ({{ item.count }})
          </router-link>
        </li>
      </ul>
    </div>
  </div>
  <div class="mobil-sidebar lg:hidden mb-4 flex items-center justify-end" v-if="$route.name === 'topicList'">
    <div class="relative">
      <select class="block appearance-none w-full border border-gray-400 textColorDarkBlack py-2 px-4 pr-8 rounded leading-tight focus:outline-none bg-white focus:border-gray-500" id="filterBtn"
        @change="mobileFilter()" v-model="type">
        <option value="0">未分類 ( {{ uncatagorized }} )</option>
        <option :value="item.id" v-for="(item, index) in categories" :key="index">{{ item.name }} ( {{ item.count }} )</option>
      </select>
      <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 textColorDarkBlack">
        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
        </svg>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'SideBar',
  data () {
    return {
      relatedData: null,
      categories: null,
      uncatagorized: 0,
      type: 0
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      let self = this
      let path = '/article-categories'
      axios.get(path)
        .then((response) => {
          self.categories = response.data.data

          let count = 0
          for (let item of self.categories) {
            count += item.count
          }
          this.uncatagorized = count
        })

      let listPath = '/articles?page=1&pageSize=5'
      axios.get(listPath)
        .then((response) => {
          self.relatedData = response.data.data
        })
    },
    mobileFilter () {
      this.$router.push({ name: 'topicList', params: { topicCategory: this.type } })
    }
  }
}
</script>

<style lang="scss">
.sidebar {
  h4 {
    font-size: 15px;
    font-style: normal;
    text-transform: capitalize;
    background: #525050;
    color: white;
    padding: .5rem .6rem;
  }

  .recentPosts {
    ul {
      li {
        transition: .3s;
        &:hover {
          color: #e60012 !important;
        }
      }
    }
  }
  .categories {
    ul {
    margin: 0px 0px 0px 5px;
    list-style: none;
    line-height: 2em;
      li {
        position: relative;
        transition: .3s;
      }
    }
  }
}
  .text {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .related {
    .item {
      .hoverText {
        z-index: 5;
        color: transparent;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transition: .3s;
        background: rgba(0, 0, 0, 0);
        &:hover {
          color: rgb(255, 255, 255);
          background: rgba(0, 0, 0, 0.5);
        }
      }
    }
  }
</style>
